import React from 'react'

import styles from './guestMenu.module.css'

export default ({
  currentSite,
  openModal,
  handleSignInSuccess
}) => {
  const signInUrl = '/sign_in'

  const openSignInModal = event => {
    event.preventDefault()
    openModal({
      type: 'signIn',
      payload: {
        currentSite,
        onSignInSuccess: handleSignInSuccess,
        welcomeMsg: 'Great to have you back!'
      }
    })
  }

  return (
    <li className={styles.item}>
      <a
        href={signInUrl}
        onClick={openSignInModal}
        className={styles.link}
      >
        <span className={styles.text}>
          Sign In
        </span>
      </a>
    </li>
  )
}



// WEBPACK FOOTER //
// ./client/components/siteHeader/header/user/guestMenu.js